module.exports = __webpack_public_path__ + "static/img/zglsLogo.5aff2ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zglsLogo.jpg
// module id = uHqI
// module chunks = 29